/* priceCalculator.js */
import initNoCalc from "./PriceCalculator/noCalc";
import processTicketFee from "./PriceCalculator/ticketFeeCalculator";
import addInfoToggles from "./PriceCalculator/infoToggles";
import {convertLocalizedStringToNumber, currencyStringToValue, validateInput} from "./PriceCalculator/helperFunction";
import processCustomerPriceCalculation from "./PriceCalculator/customerPriceCalculator";
import processRevenueCalculation from "./PriceCalculator/revenueCalculator";
import processPresaleFee, {getPreSalePercent} from "./PriceCalculator/presaleFeeCalculator";


class RelevantElements {
    constructor() {
        this.calculatorElement = document.querySelector('.price-calculator');
        if (!this.calculatorElement) {
            throw new Error('Calculator container not found');
        }
        this.priceInput = this.calculatorElement.querySelector('#calculator-input-price');
        this.incrementPriceBtn = this.calculatorElement.querySelector('.btn-increment-price');
        this.decrementPriceBtn = this.calculatorElement.querySelector('.btn-decrement-price');
        this.optionsToggle = this.calculatorElement.querySelector('#calculator-options-toggle');
        this.lightshopElements = this.calculatorElement.querySelector('.pricetype-container-lightshop');
        this.networkElements = this.calculatorElement.querySelector('.pricetype-container-network');
        this.ownsaleElements = this.calculatorElement.querySelector('.pricetype-container-ownsale');
    }
}

class GroupElements {
    constructor(elements, sale) {
        this.ticketFee = elements[sale + "Elements"].querySelector('.calculator-ticket-price-' + sale);
        this.presaleFee = elements[sale + "Elements"].querySelector('.calculator-presale-price-' + sale);
        this.customerPrice = elements[sale + "Elements"].querySelector('.calculator-customer-price-' + sale);
        this.endPrice = elements[sale + "Elements"].querySelector('.calculator-footer-endprice-' + sale);
    }
}

const salePossibilities = ["lightshop", "network", "ownsale"];

export default function () {
    const calculatorElement = document.querySelector('.price-calculator');
    if (!calculatorElement) {
        return;
    }

    try {
        let relevantElements = new RelevantElements();
        if (relevantElements) {
            if (relevantElements.calculatorElement.classList.contains('no-calc')) {
                initNoCalc(relevantElements.calculatorElement, salePossibilities);
            } else {
                initCalculator(relevantElements);
            }
        }
    } catch (e) {
        console.error('Error initializing price calculator:', e);
    }
}

function initCalculator(elements) {

    let categorizedData = categorizeData(elements.calculatorElement);
    let currencyOptions = categorizedData.currencyOptions;
    let generalOptions = categorizedData.general;

    configureOptionsToggle(elements, categorizedData, currencyOptions, generalOptions);
    elements.priceInput.value = currencyStringToValue(generalOptions.standard, currencyOptions, generalOptions);

    calculatePrices(categorizedData, elements, currencyOptions, generalOptions);

    elements.priceInput.addEventListener('change', () => calculatePrices(categorizedData, elements, currencyOptions, generalOptions));
    elements.incrementPriceBtn.addEventListener('click', () => changePriceInputValue(true, elements, categorizedData, currencyOptions, generalOptions));
    elements.decrementPriceBtn.addEventListener('click', () => changePriceInputValue(false, elements, categorizedData, currencyOptions, generalOptions));

    addInfoToggles(elements.calculatorElement);
}

function categorizeData(calculatorElement) {
    let categorizedData = {};
    let currencyFields = ["currency", "position", "separator", "separator1k"];
    let data = JSON.parse(calculatorElement.dataset.calculator);

    salePossibilities.forEach(category => {
        categorizedData[category] = {};
    });
    categorizedData["currencyOptions"] = {};
    categorizedData["general"] = {};


    for (let key in data) {
        const category = salePossibilities.find(possibility => key.startsWith(possibility));

        if (category) {
            let newKey = key.replace(category + "_", "").trim();
            categorizedData[category][newKey] = data[key];
        } else if (currencyFields.includes(key)) {
            categorizedData["currencyOptions"][key] = data[key];
        } else {
            categorizedData["general"][key] = data[key];
        }
    }

    return categorizedData;
}

function configureOptionsToggle(elements, categorizedData, currencyOptions, generalOptions) {
    let optionsToggle = elements.optionsToggle;
    if (categorizedData.general.mode === 'selectable') {
        optionsToggle.addEventListener('input', () => calculatePrices(categorizedData, elements, currencyOptions, generalOptions));
    } else if (categorizedData.general.mode === 'active') {
        optionsToggle.checked = true;
        optionsToggle.disabled = true;
        optionsToggle.closest('.calculator-options').classList.add('opacity-50');
    } else {
        optionsToggle.checked = false;
        optionsToggle.disabled = true;
        optionsToggle.closest('.calculator-options').classList.add('opacity-50');
    }
}

function changePriceInputValue(plus, elements, categorizedData, currencyOptions, generalOptions) {
    let steps;

    if (generalOptions.rounding_enable === "1") {
        steps = convertLocalizedStringToNumber(generalOptions.rounding, currencyOptions);
    } else {
        steps = 1;
    }

    if (plus) {
        elements.priceInput.value = (currencyStringToValue(elements.priceInput.value, currencyOptions, generalOptions) + steps).toFixed(2);
    } else {
        elements.priceInput.value = (currencyStringToValue(elements.priceInput.value, currencyOptions, generalOptions) - steps).toFixed(2);
    }

    calculatePrices(categorizedData, elements, currencyOptions, generalOptions);
}

function calculatePrices(categorizedData, elements, currencyOptions, generalOptions) {

    elements.priceInput.value = validateInput(elements.priceInput.value, currencyOptions, generalOptions);
    let price = currencyStringToValue(elements.priceInput.value, currencyOptions, generalOptions);
    const includingFees = elements.optionsToggle.checked;

    for (let sale of salePossibilities) {

        let relevantData = categorizedData[sale];

        if (relevantData.display === "0") {
            continue;
        }

        let elementGroup = new GroupElements(elements, sale);

        const {presale_fee_type} = relevantData;
        let preSalePercent = getPreSalePercent(relevantData, presale_fee_type);

        let ticketFeeData = processTicketFee(price, relevantData, currencyOptions, generalOptions, elementGroup, preSalePercent, includingFees);

        processPresaleFee(price, relevantData, currencyOptions, generalOptions, elementGroup.presaleFee, preSalePercent, includingFees, ticketFeeData, sale);
        processCustomerPriceCalculation(price, currencyOptions, generalOptions, elementGroup, includingFees);
        processRevenueCalculation(price, currencyOptions, generalOptions, elementGroup, includingFees);
    }
}



